import React from "react";
import { Typography } from "@mui/material";
import { getHourFromTimestamp } from "../../../../utils";

import StyledTextContent from "./styles";

const UserItemMessage = (props) => {
  const { type, content, timestamp } = props;

  return (
    <StyledTextContent>
      <div className="left-section">
        <div className="text-container">
          <Typography
            variant="caption"
            color="grey"
            fontFamily="sans-serif"
            sx={{ lineHeight: 1.2 }}
          >
            {`${type === "text" ? content : `${type}`}`}
          </Typography>
        </div>
      </div>
      <div className="right-section">
        <Typography
          variant="caption"
          color="grey"
          sx={{ lineHeight: 1, fontSize: 10 }}
        >
          {getHourFromTimestamp(timestamp)}
        </Typography>
      </div>
    </StyledTextContent>
  );
};

export default UserItemMessage;
